module.exports = __webpack_public_path__ + "static/media/C3DC_Release_Notes_R9_V2.b0ad5ce9.pdf";